import React, { useEffect } from 'react'
import axios from 'axios'
import Bowser from 'bowser'
import AppRoutes from './routes'
import ReactGA from 'react-ga4'
import { idleTimer } from './Helpers/idleTimer'
import config from 'config/config'

const App = ({ instance }) => {
  const systemInfo = {
    ip: '',
    deviceId: '',
    source: 'MyServices.mass.gov Portal'
  }
  const browser = Bowser.getParser(navigator.userAgent)
  useEffect(() => {
    ReactGA.initialize(config.GA4_KEY)
    idleTimer(instance)
    if (browser) {
      systemInfo.deviceId = browser.getPlatform().type + ' - ' + browser.getBrowser().name + ' ' + browser.getBrowser().version + ' - ' + browser.getOS().name + ' ' + browser.getOS().version || ''
    }
    axios.get('https://api.ipify.org')
      .then((response) => {
        systemInfo.ip = response.data
        sessionStorage.setItem('systemInfo', JSON.stringify(systemInfo))
      }).catch((error) => {
        console.log(error)
        systemInfo.ip = ''
        sessionStorage.setItem('systemInfo', JSON.stringify(systemInfo))
      })
  }, [])
  return <AppRoutes />
}

export default App
